<div class="car-page">

  <ng-template #attente>
    <div class="car-progress-bar">
      <div class="car-progress-bar__inner"></div>
    </div>
  </ng-template>
  <div *ngIf="enregistrementTerminer; else attente"></div>

  <header class="car-page__header pb-4">
    <h1 class="car-page__title">
      <span class="car-page__title-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
      </span>
      Modèle Caractéristiques
    </h1>
    <p class="car-page__subtitle">Gérer les modèles et ses caractéristiques</p>
  </header>

  <section class="car-panel">

    <div class="car-panel__header">

      <span class="car-panel__icon">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
          <rect x="9" y="3" width="6" height="4" rx="1" />
        </svg>
      </span>
      Gestion des modèles
    </div>

    <div class="car-panel__body">
      <form #f="ngForm" (ngSubmit)="ajouter(f)">

        <div class="car-form-row">

          <div class="car-field car-field--grow">
            <label class="car-label">Désignation modèle</label>
            <input class="car-input" type="text" [disabled]="disabled" name="ecArtCarMod_Label"
              #ecArtCarMod_Label="ngModel" [(ngModel)]="caracteristiqueModel.ecArtCarMod_Label"
              placeholder="Désignation modèle" required />
          </div>

          <button type="submit" [disabled]="disabled" class="car-btn car-btn--primary">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            Ajouter
          </button>

          <button type="button" (click)="modifier()" class="car-btn" style="background: #22c55e; color: #fff;">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
              <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
              <path d="M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
            </svg>
            Modifier
          </button>

          <button type="button" [disabled]="disabledBtnSupprimer" (click)="supprimer()" class="car-btn car-btn--danger">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4h6v2" />
            </svg>
            Supprimer
          </button>

        </div>
      </form>

      <div class="car-toolbar">
        <div class="car-search" style="max-width: 300px;">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input class="car-search__input" type="text" (keyup)="applyFilter($event.target.value)"
            placeholder="Filtrer…" />
        </div>
      </div>

      <div class="car-table-wrap">
        <table class="car-table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Texte</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let element of dataSource.data ?? dataSource" (click)="selectRow($event, element)"
              [class.selected]="element === rowSelected">
              <td class="code">{{ element.ecArtCarMod_Id }}</td>
              <td>
                <input class="car-input car-input--ghost" type="text" (blur)="modifier()"
                  [name]="'caracteristiqueText2' + element.ecArtCarMod_Id" [(ngModel)]="element.ecArtCarMod_Label" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </section>
</div>